import { Link } from "@inertiajs/react"
import type { ReactNode } from "react"

const COMBINED_REGEX = /(?:#([a-záéíóúñü\w]+))|(?:@([\w]+))/gi

interface MentionTextProps {
  text: string
}

export default function MentionText({ text }: MentionTextProps) {
  const parts: ReactNode[] = []
  let lastIndex = 0

  for (const match of text.matchAll(COMBINED_REGEX)) {
    const startIndex = match.index

    if (startIndex > lastIndex) {
      parts.push(text.slice(lastIndex, startIndex))
    }

    if (match[1]) {
      // Hashtag match
      const tag = match[1]
      parts.push(
        <Link
          key={`hashtag-${tag}-${startIndex}`}
          href={`/buscar?hashtag=${encodeURIComponent(tag.toLowerCase())}`}
          className="text-krown-300 hover:text-krown-200 font-medium hover:underline"
        >
          #{tag}
        </Link>,
      )
    } else if (match[2]) {
      // Mention match
      const nickname = match[2]
      parts.push(
        <Link
          key={`mention-${nickname}-${startIndex}`}
          href={`/buscar?q=${encodeURIComponent(nickname)}`}
          className="text-krown-300 hover:text-krown-200 font-semibold hover:underline"
        >
          @{nickname}
        </Link>,
      )
    }

    lastIndex = startIndex + match[0].length
  }

  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex))
  }

  if (parts.length === 0) {
    return <>{text}</>
  }

  return <>{parts}</>
}
